import { ModulesActionTypes } from './constants';
import { ModulesAction, Module } from './actions';

interface ModulesState {
    modules: Module[];
    loading: boolean;
    error: string | null;
    successMessage: string | null;
}

const initialState: ModulesState = {
    modules: [],
    loading: false,
    error: null,
    successMessage: null,
};

export const modulesReducer = (state = initialState, action: ModulesAction): ModulesState => {
    switch (action.type) {
        case ModulesActionTypes.MODULE_LIST:
            return { ...state, loading: true, error: null, successMessage: null };
        case ModulesActionTypes.MODULE_LIST_SUCCESS:
            return { ...state, loading: false, modules: action.payload };
        case ModulesActionTypes.MODULE_LIST_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        case ModulesActionTypes.MODULE_ADD:
            return { ...state, loading: true, error: null, successMessage: null };
        case ModulesActionTypes.MODULE_ADD_SUCCESS:
            return { ...state, loading: false, successMessage: action.payload.message };
        case ModulesActionTypes.MODULE_ADD_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        case ModulesActionTypes.MODULE_UPDATE:
            return { ...state, loading: true, error: null, successMessage: null };
        case ModulesActionTypes.MODULE_UPDATE_SUCCESS:
            return { ...state, loading: false, successMessage: action.payload.message };
        case ModulesActionTypes.MODULE_UPDATE_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        case ModulesActionTypes.MODULE_UPDATE_STATUS:
            return { ...state, loading: true, error: null, successMessage: null };
        case ModulesActionTypes.MODULE_UPDATE_STATUS_SUCCESS:
            return { ...state, loading: false, successMessage: action.payload.message };
        case ModulesActionTypes.MODULE_UPDATE_STATUS_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        case ModulesActionTypes.MODULE_DELETE:
            return { ...state, loading: true, error: null, successMessage: null };
        case ModulesActionTypes.MODULE_DELETE_SUCCESS:
            return { ...state, loading: false, successMessage: action.payload.message };
        case ModulesActionTypes.MODULE_DELETE_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        default:
            return state;
    }
};

export default modulesReducer;
